import { convertOldButtonProps, convertOldTextButtonProps } from '../button/converter.old';
import type { OldButtonProps, OldTextButtonProps } from '../button/converter.old';
import type { DropdownCompositeProps as DropdownCompositeNewProps } from './DropdownComposite';
import type {
  DropdownCompositeDropdownOption as DropdownCompositeDropdownOptionNew,
  DropdownCompositeOption as DropdownCompositeOptionNew,
} from './types';

export interface OldDropdownCompositeOption<OptionValue>
  extends Omit<DropdownCompositeOptionNew<OptionValue>, 'submitButtonProps' | 'resetButtonProps'> {
  submitButtonProps?: OldButtonProps;
  resetButtonProps?: OldTextButtonProps;
}

export interface OldDropdownCompositeDropdownOption<OptionValue>
  extends Omit<DropdownCompositeDropdownOptionNew<OptionValue>, 'options'> {
  options: Array<OldDropdownCompositeOption<OptionValue>>;
}

export interface OldDropdownCompositeProps<OptionValue>
  extends Omit<DropdownCompositeNewProps<OptionValue>, 'dropdownProps' | 'highlighted' | 'size'> {
  dropdownProps: OldDropdownCompositeDropdownOption<OptionValue>;
}

export function convertOldDropdownCompositeProps<OptionValue>(
  props: OldDropdownCompositeProps<OptionValue>,
): DropdownCompositeNewProps<OptionValue> {
  return {
    ...props,
    dropdownProps: {
      ...props.dropdownProps,
      options: props.dropdownProps.options.map(({ submitButtonProps, resetButtonProps, ...option }) => ({
        ...option,
        submitButtonProps: submitButtonProps ? convertOldButtonProps(submitButtonProps) : undefined,
        resetButtonProps: resetButtonProps ? convertOldTextButtonProps(resetButtonProps) : undefined,
      })),
    },
  };
}
